const Divider = {
  defaultProps: { size: 'md' },
  sizes: {
    lg: { borderWidth: '4px' },
    md: { borderWidth: '2px' },
    sm: { borderWidth: '1px' },
  },
}

export default Divider
